/* Side cart drawer: opens on Add to Cart, shows shipping bar and recommendations. */
(function () {
  'use strict';
  var root = document.getElementById('CartDrawer');
  if (!root) { return; }
  var FREE = (parseFloat(root.getAttribute('data-free')) || 700) * 100;
  var FEE = (parseFloat(root.getAttribute('data-fee')) || 50) * 100;
  var el = {
    count: root.querySelector('.cd__count'),
    msg: root.querySelector('.cd__msg'),
    ship: root.querySelector('.cd__ship'),
    items: root.querySelector('.cd__items'),
    recs: root.querySelector('.cd__recs'),
    foot: root.querySelector('.cd__foot'),
    panel: root.querySelector('.cd__panel')
  };
  var cartState = null, pool = [], poolSeed = null, lastFocus = null;
  var onCartPage = /^\/cart\/?$/.test(window.location.pathname);

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(c) {
    var fmt = (window.theme && window.theme.moneyFormat) || 'Rs. {{amount}}';
    var whole = (c % 100 === 0);
    var amt = (c / 100).toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amt).replace(/<[^>]*>/g, '');
  }
  function toCents(p) {
    if (typeof p === 'string') { return Math.round(parseFloat(p) * 100); }
    return p || 0;
  }
  function small(url, w) {
    if (!url) { return ''; }
    return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2');
  }
  function jsonOrNull(r) { return r.json().catch(function () { return null; }); }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeQty(key, q) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: q })
    }).then(jsonOrNull);
  }
  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return jsonOrNull(r).then(function (j) { return { ok: r.ok, j: j }; }); });
  }

  function showMsg(t) {
    if (!t) { el.msg.hidden = true; el.msg.textContent = ''; return; }
    el.msg.textContent = t;
    el.msg.hidden = false;
  }

  function renderShipping(cart) {
    if (!cart.items.length || !cart.requires_shipping) {
      el.ship.hidden = true;
      return { fee: 0, show: false };
    }
    var sub = cart.total_price;
    var free = sub >= FREE;
    var pct = Math.min(100, Math.round(sub / FREE * 100));
    el.ship.hidden = false;
    el.ship.className = 'cd__ship' + (free ? ' is-free' : '');
    el.ship.innerHTML =
      '<p class="cd__ship-text">' +
      (free ? 'You have unlocked <b>free shipping</b>.' : 'Add <b>' + esc(money(FREE - sub)) + '</b> more to get <b>free shipping</b>.') +
      '</p><div class="cd__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
    return { fee: free ? 0 : FEE, show: true, free: free };
  }

  function renderItems(cart) {
    if (!cart.items.length) {
      el.items.innerHTML = '<div class="cd__empty"><p>Your cart is empty.</p></div>';
      return;
    }
    el.items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? small(it.image, 160) : '';
      var price = '';
      if (it.original_line_price > it.final_line_price) {
        price += '<s>' + esc(money(it.original_line_price)) + '</s>';
      }
      price += esc(money(it.final_line_price));
      return '<div class="cd-item" data-key="' + esc(it.key) + '">' +
        '<a class="cd-item__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cd-item__main">' +
          '<a class="cd-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (it.variant_title ? '<div class="cd-item__var">' + esc(it.variant_title) + '</div>' : '') +
          '<div class="cd-item__row">' +
            '<div class="cd-qty"><button type="button" data-cd="dec" aria-label="Decrease quantity">-</button><span>' + it.quantity + '</span><button type="button" data-cd="inc" aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="cd-item__rm" data-cd="rm">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd-item__price">' + price + '</div>' +
      '</div>';
    }).join('');
  }

  function renderFoot(cart, ship) {
    if (!cart.items.length) { el.foot.hidden = true; return; }
    el.foot.hidden = false;
    var total = cart.total_price + (ship.show ? ship.fee : 0);
    var html = '<div class="cd-row"><span>Subtotal</span><b>' + esc(money(cart.total_price)) + '</b></div>';
    if (ship.show) {
      html += '<div class="cd-row"><span>Shipping' +
        (ship.free ? '' : '<small>Free on orders over ' + esc(money(FREE)) + '</small>') +
        '</span><b>' + (ship.free ? '<span class="cd-free">Free</span>' : esc(money(ship.fee))) + '</b></div>';
    }
    html += '<div class="cd-row cd-row--total"><span>Estimated total</span><span>' + esc(money(total)) + '</span></div>' +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="cd-btn">Checkout</button></form>' +
      '<a class="cd-link" href="/cart">View full cart</a>';
    el.foot.innerHTML = html;
  }

  function renderRecs(cart) {
    if (!cart) { return; }
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var list = pool.filter(function (p) { return !inCart[p.id] && p.variant; }).slice(0, 3);
    if (!list.length) { el.recs.innerHTML = ''; return; }
    el.recs.innerHTML = '<h3 class="cd__recs-title">You may also like</h3>' + list.map(function (p) {
      var action = p.single
        ? '<button type="button" class="cd-rec__add" data-cd="add" data-variant="' + p.variant.id + '">Add</button>'
        : '<a class="cd-rec__add" href="' + esc(p.url) + '">Options</a>';
      return '<div class="cd-rec">' +
        '<a class="cd-rec__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(small(p.image, 120)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cd-rec__main"><a class="cd-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="cd-rec__price">' + (p.single ? '' : 'From ') + esc(money(p.variant.price)) + '</div></div>' + action + '</div>';
    }).join('');
  }

  function normalize(list) {
    var seen = {}, out = [];
    list.forEach(function (p) {
      if (!p || seen[p.id]) { return; }
      seen[p.id] = true;
      var vs = (p.variants || []).map(function (v) { return { id: v.id, available: v.available !== false, price: toCents(v.price) }; });
      var avail = vs.filter(function (v) { return v.available; });
      var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      if (img && typeof img === 'object') { img = img.url || img.src || ''; }
      out.push({
        id: p.id, title: p.title, url: p.url || ('/products/' + p.handle), image: img,
        variant: avail[0] || null, single: vs.length === 1 && avail.length === 1
      });
    });
    return out;
  }

  function loadPool(cart) {
    var seed = cart.items.length ? cart.items[0].product_id : 0;
    if (poolSeed === seed && pool.length) { renderRecs(cart); return; }
    poolSeed = seed;
    var first = seed
      ? fetch('/recommendations/products.json?product_id=' + seed + '&limit=10&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; })
      : Promise.resolve({ products: [] });
    first.then(function (d) {
      var list = d.products || [];
      if (list.length >= 3) { return list; }
      return fetch('/collections/all/products.json?limit=12').then(function (r) { return r.json(); })
        .then(function (f) { return list.concat(f.products || []); }).catch(function () { return list; });
    }).then(function (list) {
      if (poolSeed !== seed) { return; }
      pool = normalize(list);
      renderRecs(cartState);
    });
  }

  function render(cart) {
    cartState = cart;
    el.count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var counters = document.querySelectorAll('.cart-count');
    for (var i = 0; i < counters.length; i++) {
      counters[i].textContent = cart.item_count;
      counters[i].classList.toggle('hidden-count', cart.item_count === 0);
    }
    var ship = renderShipping(cart);
    renderItems(cart);
    renderFoot(cart, ship);
    renderRecs(cart);
    loadPool(cart);
  }

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    setTimeout(function () { el.panel.focus(); }, 60);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
    showMsg('');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function refresh(openAfter) {
    return getCart().then(function (c) { render(c); if (openAfter) { open(); } });
  }
  function busy(on) { root.classList.toggle('is-busy', !!on); }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cd],[data-cd-close]');
    if (!t) { return; }
    if (t.hasAttribute('data-cd-close')) { close(); return; }
    var act = t.getAttribute('data-cd');
    if (act === 'add') {
      t.disabled = true;
      t.textContent = 'Adding';
      showMsg('');
      addVariant(parseInt(t.getAttribute('data-variant'), 10)).then(function (res) {
        if (!res.ok) { showMsg((res.j && (res.j.description || res.j.message)) || 'Could not add this item.'); }
        return refresh(false);
      }).catch(function () { refresh(false); });
      return;
    }
    var row = t.closest('.cd-item');
    if (!row || !cartState) { return; }
    var key = row.getAttribute('data-key');
    var item = cartState.items.filter(function (it) { return it.key === key; })[0];
    if (!item) { return; }
    var q = act === 'inc' ? item.quantity + 1 : act === 'dec' ? item.quantity - 1 : 0;
    showMsg('');
    busy(true);
    changeQty(key, Math.max(0, q)).then(function (c) {
      if (c && c.items) { render(c); } else { return refresh(false); }
    }).catch(function () { return refresh(false); }).then(function () { busy(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) { return; }
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = root.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex="0"]');
      if (!f.length) { return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === el.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Add to Cart on product pages and anywhere else that posts to /cart/add */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) { return; }
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) { return; }
    if (e.submitter && e.submitter.name === 'checkout') { return; }
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { return jsonOrNull(r).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return getCart().then(function (c) {
          render(c);
          showMsg(res.ok ? '' : ((res.j && (res.j.description || res.j.message)) || 'Could not add this item.'));
          open();
        });
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = false; } });
  }, true);

  /* Header cart icon opens the drawer instead of the cart page */
  document.addEventListener('click', function (e) {
    if (onCartPage || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) { return; }
    var a = e.target.closest('a.cart-page-link');
    if (!a) { return; }
    e.preventDefault();
    refresh(true).catch(function () { window.location.href = '/cart'; });
  });

  window.CartDrawer = { open: open, close: close, refresh: refresh };
  getCart().then(function (c) { cartState = c; loadPool(c); }).catch(function () {});
})();